import type { ButtonConfig } from '../../declare'
import { useMemo, useContext } from 'react'
import { toJS } from 'mobx'
import { Button } from 'antd'
import { FormPage, EasyModal, EasyIcon, FormPropsContext, ListTableContext, EditContext } from 'src/components'
import { appStore } from 'src/stores'
import { $consts } from 'src/plugins'
import { getValidNavColumns, getDefaultValueFrom_DEFAULT_VALUE } from 'src/components/root/helper'
import { guid } from 'src/utils/tools'
import { get } from 'lodash'

type Props = {
  config: ButtonConfig
}

const BatchAddBtn = (props: Props) => {
  const formProps = useContext(FormPropsContext)
  const table = useContext(ListTableContext)
  const edit = useContext(EditContext)

  const handleAddRows = (rows: any[]) => {
    const { __CONTEXT__: editTable } = props.config
    const { Nav_Columns = [], Nav_PageEdit } = editTable.activeTableConfig
    const rowsData: any[] = []
    rows.forEach(row => {
      const rowData: any = {
        __EDITABLE__: true,
        ID: guid(),
        ORG_ID: appStore.current.headers.OrgId,
        ENTITY_ORG_TPYE: Nav_PageEdit.EDIT_PAGE_ENTITY_ORG_TYPE || 0,
      }
      Nav_PageEdit.RELATION_FIELD && (rowData[Nav_PageEdit.RELATION_FIELD] = edit.formBase.ID)
      getValidNavColumns(Nav_Columns).forEach((item: any) => {
        const value = get(row, item.FIELD_NAME) || getDefaultValueFrom_DEFAULT_VALUE(item.DEFAULT_VALUE, {
          user: appStore.current.userinfo,
          formBase: edit.formBase,
          record: table?.selectedRow
        })
        value !== undefined && (rowData[item.FIELD_NAME] = value)
      })
      rowsData.push(rowData)
    })
    const copyDataSource = toJS(editTable.activeTableData?.dataSource || [])
    editTable.activeTable.setDataSource(copyDataSource.concat(rowsData))
  }

  const fromListRow = useMemo(() => {
    const fromWhere = formProps.formData?.fromWhere
    return (
      fromWhere?.pageType === $consts['TABLE/FORM_TYPE_LIST_PAGE']
      && fromWhere?.locateType === $consts['TABLE/BTN_LOCATE_ROW']
      && fromWhere?.data
    )
  }, [formProps.formData?.fromWhere])

  const formData = useMemo(() => {
    return {
      fromWhere: {
        pageType: $consts['TABLE/FORM_TYPE_EDIT_PAGE'],
        locateType: $consts['TABLE/BTN_LOCATE_HEADER'],
        funcType: $consts['TABLE/FUNC_TYPE_BATCH_SAVE'],
        funcData: props.config,
        data: fromListRow
      }
    }
  }, [fromListRow])

  const { LABEL, ICON, FORM_CODE, WIDTH } = props.config
  return (
    <EasyModal
      modal={{ title: FORM_CODE, width: WIDTH }}
      onClose={handleAddRows}
      slot={<Button type='primary' icon={<EasyIcon type={ICON} defaultIcon='PlusOutlined' />}>{LABEL}</Button>}
    >
      <FormPage formCode={FORM_CODE} formData={formData} />
    </EasyModal>
  )
}

export default BatchAddBtn